<template>
  <div class="permission-container">
    <!-- 左侧二级菜单 -->
    <div class="permission-sidebar">
      <div
        v-for="tab in tabs"
        :key="tab.name"
        class="sidebar-item"
        :class="{ active: activeTab === tab.name }"
        @click="handleTabClick(tab.name)"
      >
        {{ tab.label }}
      </div>
    </div>
    <!-- 内容区 -->
    <div class="permission-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'permission',
  data() {
    return {
      tabs: [
        { label: '管理员管理', name: 'admin' },
        { label: '角色管理', name: 'role' },
        { label: '子账号管理', name: 'subAccount' },
      ],
      activeTab: 'admin'
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === 'role-manage') {
          this.activeTab = 'role'
        } else if (route.name === 'subAccount-manage') {
          this.activeTab = 'subAccount'
        } else {
          this.activeTab = 'admin'
        }
      },
      immediate: true
    }
  },
  methods: {
    handleTabClick(name) {
      if (name === 'admin') {
        this.$router.push('/mall/permission/admin-manage')
      } else if (name === 'role') {
        this.$router.push('/mall/permission/role-manage')
      } else {
        this.$router.push('/mall/permission/subAccount-manage')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.permission-container {
  display: flex;
  min-height: calc(100vh - 100px);

  .permission-sidebar {
    width: 160px;
    background: #fff;
    border-radius: 8px;
    padding: 12px;
    margin-right: 16px;
    flex-shrink: 0;

    .sidebar-item {
      padding: 10px 16px;
      font-size: 14px;
      color: #606266;
      cursor: pointer;
      border-radius: 6px;
      margin-bottom: 4px;
      transition: all 0.2s ease;

      &:hover {
        background: #f5f7fa;
      }

      &.active {
        background: #ecf5ff;
        color: #667eea;
        font-weight: 500;
      }
    }
  }

  .permission-content {
    flex: 1;
    min-width: 0;
  }
}
</style>
